// extracted by mini-css-extract-plugin
export default {"container":"styles_container__dQTph","chat":"styles_chat__mL-hT","chat-completion-action-wrapper":"styles_chat-completion-action-wrapper__9sKfB"};